const mobileMenu = () => {
	// Hamburger menu: toggles the full-height panel #site-navigation (DESIGN.md §7 Header)
	const $hamburger = document.querySelector('.site-hamburger');
	const $panel = document.getElementById('site-navigation');

	if (!$hamburger || !$panel) return;

	const setOpen = (open) => {
		$panel.hidden = !open;
		document.body.classList.toggle('site-nav-open', open);
		document.body.style.overflow = open ? 'hidden' : '';
		$hamburger.setAttribute('aria-expanded', String(open));
	};

	$hamburger.addEventListener('click', () => setOpen($panel.hidden));

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && !$panel.hidden) {
			setOpen(false);
			$hamburger.focus();
		}
	});

	// The panel only exists below 992px; close it when the viewport grows past that
	window.matchMedia('(min-width: 992px)').addEventListener('change', (e) => {
		if (e.matches && !$panel.hidden) setOpen(false);
	});
};

export default mobileMenu;
